export const getSessionTiming = (appointment) => {
  const sessionStart = appointment?.orchid_pro_joined_ai_room
    ? appointment?.orchid_pro_joined_ai_room
    : appointment?.orchid_pro_joined_audio
    ? appointment?.orchid_pro_joined_audio
    : appointment?.appointment_start || "";

  const sessionEnd = appointment?.orchid_pro_left_ai_room
    ? appointment?.orchid_pro_left_ai_room
    : appointment?.orchid_pro_left_audio
    ? appointment?.orchid_pro_left_audio
    : appointment?.appointment_end || "";

  return { sessionStart, sessionEnd };
};
